import moment from "moment";

export const tagsStringToArray = (tagsString) => {
  let response = [];
  if (tagsString && tagsString.length) {
    tagsString = tagsString.replace(/ /g, "");
    response = tagsString.split(",");
  }
  return response;
};

export const tagsArrayToString = (tagsArray) => {
  let response = "";
  if (tagsArray && tagsArray.length) {
    tagsArray.forEach((value, index) => {
      if (index === tagsArray.length - 1) {
        response += value;
      } else {
        response += `${value},`;
      }
    });
  }
  return response;
};

export const orderStatusToSpanish = (orderStatus: string) => {
  if (orderStatus === "waiting_for_external_payment" || orderStatus === "started")
    return { label: "Pendiente de pago", color: "orange" };
  if (
    orderStatus === "waiting_restaurant_confirmation" ||
    orderStatus === "preparing_order" ||
    orderStatus === "waiting_pickup_client" ||
    orderStatus === "waiting_pickup_deliveryman"
  )
    return { label: "En preparación", color: "yellow" };
  if (
    orderStatus === "troubleshooting_restaurant" ||
    orderStatus === "troubleshooting_deliveryman" ||
    orderStatus === "troubleshooting_hand_off"
  )
    return { label: "Problemas con la orden", color: "orange" };
  if (orderStatus === "delivering_order") return { label: "En camino", color: "yellow" };
  if (orderStatus === "order_completed") return { label: "Completada", color: "green" };
  if (orderStatus === "order_not_generated") return { label: "No confirmada", color: "red" };
  if (
    orderStatus === "order_canceled_by_troubleshooting_delivery_man" ||
    orderStatus === "order_canceled_in_handoff" ||
    orderStatus === "order_canceled_by_restaurant"
  )
    return { label: "Cancelada", color: "red" };
};

export const orderStatusToSpanishLabel = (orderStatus: string, dealDate: string) => {
  if (orderStatus === "waiting_for_external_payment" || orderStatus === "started")
    return {
      label: `Realiza tu pago antes del ${dealDate} Si no lo haces el domiciliario te cobrará con datafono al momento de la entrega.`,
      color: "black",
    };
  if (
    orderStatus === "waiting_restaurant_confirmation" ||
    orderStatus === "preparing_order" ||
    orderStatus === "waiting_pickup_client" ||
    orderStatus === "waiting_pickup_deliveryman"
  )
    return { label: "Tu pedido está siendo preparado", color: "yellow" };
  if (
    orderStatus === "troubleshooting_restaurant" ||
    orderStatus === "troubleshooting_deliveryman" ||
    orderStatus === "troubleshooting_hand_off"
  )
    return { label: "Hay problemas con la orden", color: "orange" };
  if (orderStatus === "delivering_order") return { label: "En camino", color: "yellow" };
  if (orderStatus === "order_completed")
    return { label: "Tu pedido fue entregado", color: "green" };
  if (orderStatus === "order_not_generated")
    return { label: "Tu pedido no fue generado", color: "red" };
  if (
    orderStatus === "order_canceled_by_troubleshooting_delivery_man" ||
    orderStatus === "order_canceled_in_handoff" ||
    orderStatus === "order_canceled_by_restaurant"
  )
    return { label: "La orden ha sido cancelada", color: "red" };
};

export const subscriptionStatusToSpanish = (subscription: any) => {
  const subscriptionStatus = subscription.status;
  const { deadline_update_date } = subscription;
  if (subscriptionStatus === "pending") return { label: "Pendiente", color: "orange" };
  if (subscriptionStatus === "active") {
    const today = moment();
    const deadLineUpdateDate = moment(deadline_update_date);
    if (!isDeliveryAvailable(subscription)) return { label: "No disponible", color: "red" };
    if (today.isAfter(deadLineUpdateDate)) return { label: "Confirmada", color: "green" };
    return { label: "Pedido abierto", color: "yellow" };
  }

  if (subscriptionStatus === "skip_week") return { label: "Pedido saltado", color: "red" };
  if (subscriptionStatus === "cancel") return { label: "Cancelada", color: "red" };
  if (subscriptionStatus === "inactive") return { label: "Inactiva", color: "red" };
};

export const isOrderInTerminalStatus = (order) => {
  switch (order.status) {
    case "order_completed":
    case "order_not_generated":
    case "order_canceled_by_troubleshooting_delivery_man":
    case "order_canceled_in_handoff":
    case "order_canceled_by_restaurant":
      return true;
    default:
      return false;
  }
};

export const subscriptionDetailsStatusToSpanish = (subscription: any) => {
  const { status } = subscription;
  switch (status) {
    case "active":
      return { label: "Activa", color: "green" };
    case "skip_week":
      return { label: "Semana pausada", color: "yellow" };
    case "cancel":
      return { label: "Cancelada", color: "red" };
    case "inactive":
      return { label: "Inactiva", color: "red" };
    case "pending":
      return { label: "Pendiente", color: "orange" };
    default:
      return { label: "Sin estado", color: "red" };
  }
};

export const subcriptionCreationWeekDayToSpanish = (creationWeekDay: number) => {
  switch (creationWeekDay) {
    case 1:
      return "Lunes";
    case 2:
      return "Martes";
    case 3:
      return "Miércoles";
    case 4:
      return "Jueves";
    case 5:
      return "Viernes";
    case 6:
      return "Sábado";
    case 7:
      return "Domingo";
  }
};

export const openWALink = (subscription) => {
  const { subscription_host } = subscription;
  window.open(`https://wa.me/${subscription_host.cellphone}`, "_blank");
};

export const getMenuPriceByMenuId = (menuId, menuPrices, detailsSubscriptionMenus) => {
  const menuPrice = menuPrices.find((findMenuPrice) =>
    findMenuPrice.menus_id.find((menusId) => menusId === menuId)
  );
  const { menus_id, prices } = menuPrice;
  let totalCount = 0;
  menus_id.forEach((menusId) => {
    const { count } = detailsSubscriptionMenus.find((menu) => menu.menu_id === menusId);
    totalCount += count;
  });
  if (totalCount < prices.length) {
    return prices[totalCount];
  }
  return prices[prices.length - 1];
};

export const isDeliveryAvailable = (subscription) => {
  const { deal_date } = subscription;
  const dealDate = moment(deal_date).startOf("day");
  const limitDate = moment("2022-07-27").endOf("day");
  return dealDate.isSameOrBefore(limitDate);
};
